import { render, staticRenderFns } from "./RolesCardCreate.vue?vue&type=template&id=64b7b1e8"
import script from "./RolesCardCreate.vue?vue&type=script&lang=js"
export * from "./RolesCardCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports